import { render } from "./FooterComponenet.vue?vue&type=template&id=af09fcbc&scoped=true"
import script from "./FooterComponenet.vue?vue&type=script&lang=js"
export * from "./FooterComponenet.vue?vue&type=script&lang=js"

import "./FooterComponenet.vue?vue&type=style&index=0&id=af09fcbc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af09fcbc"]])

export default __exports__